import React, { useState } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';

const CookieConsentBanner: React.FC = () => {
  const { showBanner, acceptAll, rejectAll, showSettings } = useCookieConsent();
  const [showDetails, setShowDetails] = useState(false);

  if (!showBanner) {return null;}

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white p-4 shadow-lg border-t border-gray-700">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-2">Cookie Consent</h3>
            <p className="text-sm text-gray-300 mb-3">
              We use cookies and similar technologies to enhance your experience, analyze site usage, 
              and assist in our marketing efforts. By clicking &quot;Accept All&quot;, you consent to our use of cookies. 
              You can manage your preferences at any time using the &quot;Cookie Settings&quot; button or the link in the footer.
            </p>
            
            {showDetails && (
              <div className="mt-4 p-4 bg-gray-800 rounded-lg">
                <h4 className="font-medium mb-3">Cookie Categories:</h4>
                <div className="space-y-3 text-sm">
                  <div>
                    <strong className="text-green-400">Essential Cookies:</strong>
                    <p className="text-gray-300">
                      Required for basic site functionality, wallet connection, and security. These cannot be disabled.
                    </p>
                  </div>
                  <div>
                    <strong className="text-blue-400">Analytics Cookies:</strong>
                    <p className="text-gray-300">
                      Help us understand how visitors interact with our website through Google Analytics and Vercel Analytics.
                    </p>
                  </div>
                  <div>
                    <strong className="text-orange-400">Essential Services:</strong>
                    <p className="text-gray-300">
                      Required for core functionality: Solana RPC endpoints, decentralized storage (Lighthouse with Pinata/Arweave fallbacks), wallet providers.
                    </p>
                  </div>
                  <div>
                    <strong className="text-purple-400">Optional Services:</strong>
                    <p className="text-gray-300">
                      Enhance user experience: Google Fonts (custom typography).
                    </p>
                  </div>
                </div>
              </div>
            )}
            
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="text-sm text-blue-400 hover:text-blue-300 underline"
            >
              {showDetails ? 'Hide Details' : 'Show Details'}
            </button>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 lg:ml-4">
            <button
              onClick={rejectAll}
              className="px-4 py-2 text-sm bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
            >
              Only Necessary
            </button>
            <button
              onClick={showSettings}
              className="px-4 py-2 text-sm bg-gray-600 hover:bg-gray-500 rounded-lg transition-colors"
            >
              Cookie Settings
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-2 text-sm bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors font-medium"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
